import { RouteObject } from 'react-router-dom'
import Profile from './profile'
import NotificationSettings from './notifications'
import AccountLayout from 'layout/account/accountLayout'
import ErrorBug from 'components/errors/bugs'

export const accountRoutes: RouteObject[] = [
    {
        path: '/account',
        element: <AccountLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                path: 'profile',
                element: <Profile />,
            },
            {
                path: 'notifications',
                element: <NotificationSettings />,
            },
        ],
    },
]
